import React, { Component } from "react";
import Round1 from "./Round1";
import Round2 from "./Round2";
import Round3 from "./Round3";
import Round4 from "./Round4";
import Round5 from "./Round5";
import Round6 from "./Round6";
import Round7 from "./Round7";
import Round8 from "./Round8";
import Round9 from "./Round9";
import SimpleDarkPattern2d from "./SimpleDarkPattern2d";
import { connect } from "react-redux";
import {
	pattern2dIn,
	pattern2dOut,
	stopVoice
} from "../../actions/actionCreators.js";

const mapDispatchToProps = (dispatch) => {
	return {
		pattern2dIn: () => dispatch(pattern2dIn()),
		pattern2dOut: () => dispatch(pattern2dOut()),
		stopVoice: () => dispatch(stopVoice())		
	};
};

class Pattern2dView extends Component {

	componentDidMount() {
		this.props.pattern2dIn();
		this.allowInput = true;
	}

	userClosedAd () {
		// throttle input - so doesn't allow user to skip anything
		if (this.allowInput) {
			this.allowInput = false;
			this.props.stopVoice();
			this.props.adClicked();
		}
	}

	backupMarkup () {
		return <SimpleDarkPattern2d adComplete={ this.userClosedAd.bind(this)}  adText="" />
	}

	getDarkPattern() {

		// LEVEL 1
		if ((this.props.index === 0) && ((this.props.round === 1))) {
			return <Round1 adComplete={ this.userClosedAd.bind(this)} />;
		} 
		if ((this.props.index === 1) && ((this.props.round === 1))) {
			return <Round2 adComplete={ this.userClosedAd.bind(this)} />;
		} 
		if ((this.props.index === 2) && ((this.props.round === 1))) {
			return <Round3 adComplete={ this.userClosedAd.bind(this)} />;
		} 
		// LEVEL 2
		if ((this.props.index === 0) && ((this.props.round === 2))) {
			return <Round4 adComplete={ this.userClosedAd.bind(this)} />;
		}
		if ((this.props.index === 1) && ((this.props.round === 2))) {
			return <Round5 adComplete={ this.userClosedAd.bind(this)} />;
		}  
		if ((this.props.index === 2) && ((this.props.round === 2))) {
			return <Round6 adComplete={ this.userClosedAd.bind(this)} />;
		}  

		// LEVEL 3
		if ((this.props.index === 0) && ((this.props.round === 3))) {
			return <Round7 adComplete={ this.userClosedAd.bind(this)} />;
		}
		if ((this.props.index === 1) && ((this.props.round === 3))) {
			return <Round8 adComplete={ this.userClosedAd.bind(this)} />;
		}  
		if ((this.props.index === 2) && ((this.props.round === 3))) {
			return <Round9 adComplete={ this.userClosedAd.bind(this)} />;
		}  
		return this.backupMarkup();
	}

	componentWillUnmount () {
		this.props.pattern2dOut();
	}

	render () {
		return (
			this.getDarkPattern()
		)
	}
	
}

const Pattern2d = connect(() => ({}), mapDispatchToProps)(Pattern2dView);
export default Pattern2d;



// WEBPACK FOOTER //
// ./src/components/darkpatterns2d/Pattern2d.js